import { render, staticRenderFns } from "./SuppliersPage.vue?vue&type=template&id=6e4384bb&scoped=true"
import script from "./SuppliersPage.vue?vue&type=script&lang=js"
export * from "./SuppliersPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e4384bb",
  null
  
)

export default component.exports